@if ((tableModel$ | async); as tableModel) {
  <p-table [scTableSettings]="tableModel.tableSettings"
           class="mt-3">
    <ng-template pTemplate="tools-panel-left">
      @if (checkStatus) {
        <div class="flex align-items-center">
          @if (!tableModel.isReadonly) {
            <p-button (onClick)="checkForPlagiarism()"
                      [disabled]="plagiarismCheckInProgress"
                      label="{{ checkStatus.status === statusEnumType.Unchecked ? 'Check for Plagiarism' : 'Restart check' }}"
                      i18n-label>
            </p-button>
          }
          <sc-external-enum-tag class="ml-5"
                                [enumType]="statusEnumType"
                                [enumValue]="checkStatus.status">
          </sc-external-enum-tag>
        </div>
      }
    </ng-template>
  </p-table>
}